module.exports = __webpack_public_path__ + "static/media/lumbering7.f2748369.jpg";